import React, { useCallback, useMemo } from 'react'

import { GridFormItem } from '../../../core/components/sections'
import { getFilterOptions } from '../../../core/utils'

import { Select } from '../../../common/components/sections'
import {
  StyledPaddingBottomRow,
  StyledPaddingTopCol,
} from '../../../common/components/styled'
import { PAGINATION } from '../../../common/constants'

import { MENU_CURATION_TASK_SORT_BY } from '../../constants'
import { useMenuCurationTasksListFilters } from '../../hooks'

import MenuCurationTasksUserAllocationModal from './menu-curation-tasks-user-allocation-modal'

const MenuCurationTasksSorters = () => {
  const { sortBy, setFilters } = useMenuCurationTasksListFilters()

  const sortByOptions = useMemo(
    () => getFilterOptions(MENU_CURATION_TASK_SORT_BY, 'label', 'value'),
    [],
  )

  const handleChangeSortBy = useCallback(
    value => {
      setFilters({
        currentPage: PAGINATION.DEFAULT_PAGE,
        sortBy: value,
      })
    },
    [setFilters],
  )

  return (
    <StyledPaddingBottomRow gutter={16}>
      <GridFormItem span={4} label="Sort By">
        <Select
          allowClear
          showSearch
          value={sortBy}
          onChange={handleChangeSortBy}
          options={sortByOptions}
        />
      </GridFormItem>
      <StyledPaddingTopCol span={2}>
        <MenuCurationTasksUserAllocationModal />
      </StyledPaddingTopCol>
    </StyledPaddingBottomRow>
  )
}

export default MenuCurationTasksSorters
